import React from 'react';
import PageHero from './PageHero';
import './Services.css';

const Services = () => {
  const services = [
    {
      icon: 'fas fa-shield-virus',
      title: 'AI-Powered Cybersecurity',
      description: 'Advanced threat detection and automated incident response powered by machine learning algorithms.'
    },
    {
      icon: 'fas fa-cloud',
      title: 'Cloud Migration',
      description: 'Seamless migration to cloud platforms with optimized architecture and cost management.'
    },
    {
      icon: 'fas fa-robot',
      title: 'AI/ML Solutions',
      description: 'Custom AI and machine learning solutions to transform business operations.'
    },
    {
      icon: 'fas fa-brain',
      title: 'Generative AI (GenAI)',
      description: 'Harness the power of large language models, multimodal AI, and generative technologies to revolutionize content creation, automation, and intelligent decision-making.'
    },
    {
      icon: 'fas fa-database',
      title: 'Data Engineering',
      description: 'Build robust data pipelines, warehouses, and analytics platforms to unlock insights from your data.'
    },
    {
      icon: 'fas fa-users',
      title: 'Talent Placement',
      description: 'World-class technology professionals for your critical projects and initiatives.'
    },
    {
      icon: 'fas fa-chart-line',
      title: 'Digital Strategy',
      description: 'Strategic consulting to help you navigate the digital transformation landscape.'
    },
    {
      icon: 'fas fa-lock',
      title: 'Zero-Trust Security',
      description: 'Implement comprehensive zero-trust security architecture across your infrastructure.'
    }
  ];

  return (
    <>
      <PageHero
        title="Our Services"
        subtitle="Technology Solutions"
        description="Comprehensive technology solutions delivered across all divisions to empower your enterprise"
        sectionId="services"
      />
      <section id="services" className="services">
        <div className="container">
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card" style={{animationDelay: `${index * 0.1}s`}}>
              <div className="service-icon-wrapper">
                <i className={service.icon}></i>
              </div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
    </>
  );
};

export default Services;

